<template>
  <div class="col-sm-12" :class="grid ? 'col-md-' + grid : 'col-md-12'">
    <div class="form-group mb-2">
      <label class="d-block font-weight-bold">
        {{ label }}
        <span v-if="required" class="text-danger">*</span>
      </label>
      <div>
        <VueEditor
          v-model="text"
          @input="changeText"
          @focus="focus"
          @blur="blur"
          :disabled="disabled"
        />
        <!-- <ckeditor
                    :editor="editor"
                    v-model="text"
                    @input="changeText"
                    @ready="onEditorReady"
                    @focus="focus"
                    @blur="blur"
                    :readonly="readonly"
                    :placeholder="placeholder"
                    :required="required"
                    :config="editorConfig"
                    :disabled="disabled"
                /> -->
        <textarea
          v-model="text"
          :required="required"
          style="opacity: 0; height: 1px; position: absolute"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
  import "@ckeditor/ckeditor5-build-classic/build/translations/pt-br";
  import { VueEditor } from "vue2-editor";

  export default {
    components: { VueEditor },
    props: [
      "value",
      "disabled",
      "label",
      "required",
      "grid",
      "readonly",
      "placeholder",
      "mt",
    ],
    data() {
      return {
        editor: ClassicEditor,
        text: "",
        editorConfig: {
          language: "pt-br",
          toolbar: {
            items: [
              "heading",
              "|",
              "bold",
              "italic",
              "|",
              "link",
              "|",
              "alignment",
              "outdent",
              "indent",
              "|",
              "bulletedList",
              "numberedList",
              "|",
              "insertTable",
              "|",
              "blockQuote",
              "|",
              "undo",
              "redo",
            ],
          },
        },
      };
    },
    watch:{value(){    this.text = this.value;}},
    mounted() {
        console.log(this.value)
        this.onEditorReady();
      // CKEDITOR.config.extraAllowedContent =
      //     "input[required];" + "textarea[required];";
    },
    updated() {
      this.onEditorReady();
    },
    methods: {
      focus() {
        this.$emit("onfocus", true);
        //console.log("focus");
      },
      blur() {
        this.$emit("onblur", false);
        //console.log("blur");
      },
      onEditorReady() {
        if (this.value == undefined || this.value == null || this.value == "") {
          this.text = "";
        } else {
          this.text = this.value;
        }
      },
      changeText() {
        this.$emit("input", this.text);
      },
    },
    onSelectionChange(range) {
      console.log("selection change!", range);
    },
  };
</script>
<style lang="css">
  @import "~vue2-editor/dist/vue2-editor.css";

  /* Import the Quill styles you want */
  @import "~quill/dist/quill.core.css";
  @import "~quill/dist/quill.bubble.css";
  @import "~quill/dist/quill.snow.css";

  /* .ck.ck-editor__main > .ck-editor__editable:not(.ck-focused) {
  	border: 1px solid #5895fc !important;
  } */
  .ck.ck-editor__editable:not(.ck-editor__nested-editable).ck-focused {
    border: 1px solid #5895fc !important;
  }
  .ck.ck-editor__main > .ck-editor__editable {
    margin-top: 10px !important;
    min-height: 100px !important;
    max-height: 600px !important;
    border-radius: 2px !important;
  }
  .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
  .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
    border: 1px solid #e6e6e6 !important;
    border-radius: 2px !important;
  }
  .ck-read-only {
    background: #efefef !important;
  }
</style>
